import { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Service.scss";
import { useState } from "react";
import { api } from "../../services/api/api";
import Loading from "../../components/loading/Loading";
import { Breadcrumb } from "../../components/breadcrumb/Breadcrumb";
import { Card, Typography } from "@material-tailwind/react";
import { t } from "i18next";

export function Service() {
    const { id } = useParams();
    const [service, setService] = useState<EasyTech.Service>();
    const [path, setPath] = useState<{ name: string; path: string }[]>([]);

    useEffect(() => {
        api.get(`users/services/${id}`).then((ret) => {
            setService(ret as EasyTech.Service);
        });
    }, [id]);

    useEffect(() => {
        if (service) {
            setPath([
                { name: t("common:services:label"), path: "/services" },
                { name: service.label, path: `/services/${service.id}` },
            ]);
        }
    }, [service]);


    return (
        <div className="service-details">
            {service ? (
                <>
                    <Breadcrumb path={path} />

                    <div className="flex justify-between items-center">
                        <Typography variant="h2">{service.label}</Typography>
                    </div>

                    <Typography variant="h4" className="sub-title">
                        {t("piece:informations")}
                    </Typography>

                    <Card className="details-card">
                        <div className="field">
                            <label>{t("common:name")}</label>
                            <Typography>{service.label}</Typography>
                        </div>

                        <div className="field">
                            <label>{t("common:ref:label")}</label>
                            <Typography>{service.ref || "-"}</Typography>
                        </div>

                        <div className="field">
                            <label>{t("common:sellingPrice")}</label>
                            <Typography>{service.price ?? "-"}</Typography>
                        </div>

                        {service.type && (
                            <div className="field">
                                <label>{t("common:type")}</label>
                                <Typography>{service.type}</Typography>
                            </div>
                        )}

                        <div className="field">
                            <label>{t("common:category")}</label>
                            <Typography>{service.category?.label || "-"}</Typography>
                        </div>
                    </Card>
                </>
            ) : (
                <Loading />
            )}
        </div>
    );
}
